import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import * as Sentry from "@sentry/react";
import {BrowserRouter} from "react-router-dom";

Sentry.init({
    dsn: "https://484c10eb0d60c698936a12dd41207fcb@o1354288.ingest.us.sentry.io/4508992914128896",
    integrations: [
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({
            levels: ['error']
        })
    ],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: import.meta.env.VITE_ENV_NAME,
    enabled: import.meta.env.VITE_ENV_NAME !== 'dev'
});


createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <BrowserRouter>
          <App />
      </BrowserRouter>
  </StrictMode>,
)
